import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-276372fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "text-lg font-bold text-gray-400 border-b pb-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "bg-red-100"
}
const _hoisted_5 = { class: "flex flex-row mt-5 gap-x-2" }
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "whitespace-nowrap font-bold text-sm" }, "Maximum Buy Price", -1))
const _hoisted_8 = { class: "border border-gray-400 rounded flex" }
const _hoisted_9 = { class: "flex-1 text-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "¢", -1))
const _hoisted_11 = { class: "flex-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "whitespace-nowrap font-bold text-sm" }, "Rounds", -1))
const _hoisted_13 = { class: "border border-gray-400 rounded flex" }
const _hoisted_14 = { class: "flex-1 text-center" }
const _hoisted_15 = { class: "flex flex-row text-sm" }
const _hoisted_16 = { class: "flex-1" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "candidates" }, "Skip Confirmation", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Read the Rules", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_autowidth = _resolveDirective("autowidth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _createTextVNode("Submit a Buy Order "),
      (_ctx.priceIsLocked)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " at " + _toDisplayString(_ctx.milliCents) + "¢", 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.decrCent && _ctx.decrCent(...args))),
            class: "inline-block cursor-pointer bg-slate-100 p-3 text-indigo-500 hover:bg-indigo-200 rounded-l"
          }, "-1¢"),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              class: "inline border-0 text-right w-16 p-0 my-3 focus:outline-none focus:border-none",
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.milliCents) = $event))
            }, null, 512), [
              [_directive_autowidth, { minWidth: `${_ctx.milliCents.toString().length * 10}px` }],
              [_vModelText, _ctx.milliCents]
            ]),
            _hoisted_10
          ]),
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.incrCent && _ctx.incrCent(...args))),
            class: "inline-block cursor-pointer bg-slate-100 p-3 text-indigo-500 hover:bg-indigo-200 rounded-r"
          }, "+1¢")
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.decrBox && _ctx.decrBox(...args))),
            class: "inline-block cursor-pointer bg-slate-100 p-3 text-indigo-500 hover:bg-indigo-200 rounded-l"
          }, "-"),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              class: "inline border-0 text-right w-16 p-0 my-3 focus:outline-none focus:border-none",
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rounds) = $event))
            }, null, 512), [
              [_directive_autowidth, { minWidth: `${_ctx.rounds.toString().length * 10}px` }],
              [_vModelText, _ctx.rounds]
            ])
          ]),
          _createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.incrBox && _ctx.incrBox(...args))),
            class: "inline-block cursor-pointer bg-slate-100 p-3 text-indigo-500 hover:bg-indigo-200 rounded-l"
          }, "+")
        ])
      ])
    ]),
    _createElementVNode("button", {
      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submitOrder && _ctx.submitOrder(...args))),
      class: "my-4 w-full bg-indigo-500 hover:bg-indigo-600 text-white border px-5 py-2 rounded"
    }, _toDisplayString(_ctx.skipConfirmation ? 'Submit Order' : 'Next'), 1),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _withDirectives(_createElementVNode("input", {
          id: "candidates",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.skipConfirmation) = $event)),
          name: "candidates",
          type: "checkbox",
          class: "h-4 w-4 mr-2 text-indigo-600 border-gray-300 rounded"
        }, null, 512), [
          [_vModelCheckbox, _ctx.skipConfirmation]
        ]),
        _hoisted_17
      ]),
      _hoisted_18
    ])
  ]))
}